(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["policies"] && !Shopify.designMode) return;
  try {
    

const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");

accordionItemHeaders.forEach(accordionItemHeader => {
   accordionItemHeader.addEventListener("click", event => {
    
     // Uncomment in case you only want to allow for the display of only one collapsed item at a time!
    
    const currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");
    if(currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader!==accordionItemHeader) {
       currentlyActiveAccordionItemHeader.classList.toggle("active");
       currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
     }

     accordionItemHeader.classList.toggle("active");
     const accordionItemBody = accordionItemHeader.nextElementSibling;
     if(accordionItemHeader.classList.contains("active")) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
     }
     else {
       accordionItemBody.style.maxHeight = 0;
     }
    
   });
});

function updateLocation(value) {
    localStorage.setItem('selectedMenu', value);
    location.href = value;
}

// Restore selected value from local storage on page load
window.onload = function() {
    var selectedValue = localStorage.getItem('selectedMenu');
    if (selectedValue) {
        var options = document.getElementById('menuDropdown').options;
        for (var i = 0; i < options.length; i++) {
            if (options[i].value === selectedValue) {
                options[i].setAttribute('selected', 'selected');
            } else {
                options[i].removeAttribute('selected');
            }
        }
    }
};
  

  } catch(e) { console.error(e); }
})();
})();
